/**
 * 安保管理路由
 */
 const Layout = () => import(/* webpackChunkName: "Layout" */'@serviceapp/securityManage/Router.vue')
 export default [
     {
         path: '/securityManage',
         name: 'securityManage',
         component: Layout,
         meta: { text: '安消一体' },
         children: [
             {
                 path: 'eventRecord',
                 name: 'eventRecord',
                 component: () => import(/* webpackChunkName: "eventRecord" */'@serviceapp/securityManage/eventRecord/Index.vue'),
                 meta: { text: '事件记录' }
             },
             {
                path: 'eventReport',
                name: 'eventReport',
                component: () => import(/* webpackChunkName: "eventReport" */'@serviceapp/securityManage/eventReport/Index.vue'),
                meta: { text: '事件上报' }
            },
            {
                path: 'patrolManage',
                name: 'patrolManage',
                component: () => import(/* webpackChunkName: "patrolManage" */'@serviceapp/securityManage/patrolManage/Index.vue'),
                meta: { text: '巡更管理' }
            },
            {
                path: 'securityStatistics',
                name: 'securityStatistics',
                component: () => import(/* webpackChunkName: "securityStatistics" */'@serviceapp/securityManage/securityStatistics/Index.vue'),
                meta: { text: '安保统计' }
            },
            {
                path: 'securityView',
                name: 'securityView',
                component: () => import(/* webpackChunkName: "securityView" */'@serviceapp/securityManage/securityView/Index.vue'),
                meta: { text: '消防可视化' }
            }
         ]
     },
 ]